<template lang="html">
  <div class="sub-main column">
    <div class="sub-nav row">
			<nav>
				<router-link :to="{ name: item.uri }" class="item" v-for="item in menu" v-bind:key="item.key">
					{{ item.name }}
				</router-link>
			</nav>
    </div>
	<div class="sub-page row">
		<keep-alive include="Board">
			<router-view></router-view>
		</keep-alive>
	</div>
  </div>
</template>

<script>
export default {
	name: 'Home',
	data () {
		return {
			search: null,
			menu: [
				{
					key: 0,
					name: 'Tableau de Bord',
					uri: 'Board'
				},
				{
					key: 1,
					name: 'Activité',
					uri: 'Activity'
				},
				{
					key: 2,
					name: 'Contacts',
					uri: 'Contacts'
				}
			]
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// index.vue?181a4f96